module.exports = __webpack_public_path__ + "img/company-introduce.72d91d56.png";